import { useState, useMemo } from "react";
import PageHero from "@/components/PageHero";
import { GALLERY } from "@/lib/data";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const CATS = ["All", "Agriculture", "Dairy", "Construction", "Petroleum", "Education", "Group"];

export default function Gallery() {
  const [cat, setCat] = useState("All");
  const [open, setOpen] = useState(null);
  const items = useMemo(() => cat === "All" ? GALLERY : GALLERY.filter(g => g.cat === cat), [cat]);

  return (
    <div data-testid="gallery-page">
      <PageHero
        eyebrow="Gallery"
        title={<>Moments from the <em className="not-italic font-serif italic text-shramik-green">Shramik ecosystem.</em></>}
        subtitle="Behind-the-scenes images from our fields, factories, sites and community programs."
      />
      <section className="py-14">
        <div className="container-page">
          <div className="flex flex-wrap gap-2 mb-10" data-testid="gallery-filters">
            {CATS.map(c => (
              <button key={c} onClick={() => setCat(c)} data-testid={`gallery-filter-${c.toLowerCase()}`}
                className={`px-4 py-2 rounded-full text-sm font-medium ${cat === c ? "bg-shramik-green text-white" : "bg-slate-100 hover:bg-shramik-greenLight text-slate-700"}`}>{c}</button>
            ))}
          </div>

          <div className="columns-2 md:columns-3 lg:columns-4 gap-4" data-testid="gallery-grid">
            {items.map((g, i) => (
              <motion.button
                key={i}
                onClick={() => setOpen(i)}
                data-testid={`gallery-item-${i}`}
                initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once:true}} transition={{duration:0.5, delay:i*0.04}}
                className="block w-full mb-4 rounded-2xl overflow-hidden group"
              >
                <img src={g.src} alt={g.cat} loading="lazy" className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"/>
              </motion.button>
            ))}
          </div>
        </div>
      </section>

      <AnimatePresence>
        {open !== null && (
          <motion.div
            initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}
            className="fixed inset-0 bg-black/90 z-[60] flex items-center justify-center p-4"
            onClick={() => setOpen(null)}
            data-testid="lightbox"
          >
            <button className="absolute top-6 right-6 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" aria-label="close" onClick={() => setOpen(null)}><X className="w-5 h-5"/></button>
            <motion.img initial={{scale:0.95}} animate={{scale:1}} src={items[open].src} alt="" className="max-h-[85vh] max-w-full rounded-xl shadow-2xl"/>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
